import Table from '../../components/TableAntd'
import { Button, Input, Space, Tooltip, Form, Select } from 'antd'
import { RightCircleFilled, LeftCircleFilled } from '@ant-design/icons'
import CustomTreeAll from '../../components/TreeAll'
import CustomeIcon from '../../components/IconUser'
import Search from '../../components/SearchFilter'
import Buttonbar from '../../components/ButtonBar'
import Style from './goodslist.module.scss'
import usegoodslisthooks from './hooks'
import { useTypedSelector } from '../../redux/store'
import moment from 'moment'
import {
  CategorySourceData,
  PlatformField,
} from '../../modules/goodsdetailmodules/reducer'
import { useMemo } from 'react'
import CustomModal from '@/components/ModalUser'
import { reportTypeList } from '@/global/enum/product'
// 商品列表页
const Goodslist = () => {
  const { treeList } = useTypedSelector((state) => state.treeReducer)
  const {
    dataSource,
    pages,
    selectData,
    searchState,
    searchValue,
    treevisible,
    submissionVisible,
    filteredPlatformList,
    submissionLoading,
    submissionForm,
    sortParams,
    onSearch,
    onChange,
    onChangeCheck,
    onRefresh,
    onSearchMod,
    onhandlDetail,
    selectNode,
    onAddgoods,
    onChangetree,
    jumpBatchImport,
    exportGoodsDetail,
    handleGoodsSubmission,
    handleGoodsSubmissionCancel,
    handleGoodsSubmissionSubmit,
    onSortChange,
  } = usegoodslisthooks()
  const treeRef = useMemo(
    () => treeList.filter((item) => item.source !== CategorySourceData.PLM),
    [treeList],
  )

  const listColumn = [
    {
      key: 'srmProductTypeName',
      title: '物料类型',
      width: 75,
      render: (text: string) =>
        text === '落地商物料' ? '电商供应商物料' : text,
    },
    {
      key: 'code',
      title: '编码',
      width: 81,
      render: (text: any, record: any) => {
        return (
          <span className={'primaryBtn'} onClick={() => onhandlDetail(record)}>
            {text}
          </span>
        )
      },
    },
    {
      key: 'name',
      title: '名称',
      width: 94,
      render: (text: any, record: any) => {
        return record.needConfirmPic === '1' ? (
          <Tooltip
            title="图片被重新覆盖，请预览确认"
            getPopupContainer={() => document.body}
          >
            <span>{text}</span>
          </Tooltip>
        ) : (
          text
        )
      },
    },
    {
      key: 'brandName',
      title: '品牌',
      width: 95,
    },
    {
      key: 'manuCode',
      title: '型号规格',
      width: 95,
    },
    {
      key: 'unitName',
      title: '单位',
      width: 75,
    },

    {
      key: 'supplyPrice',
      title: '参考供货价',
      width: 75,
    },
    {
      key: 'relationPlatformCodeAndNames',
      title: '关联项目',
      width: 75,
      render: (text: any) => {
        return text?.map((item: any) => item.name)?.join(',')
      },
    },
    {
      key: 'pushPlatformCodeAndNames',
      title: '已推送项目',
      width: 75,
      render: (text: any) => {
        return text?.map((item: any) => item.name)?.join(',')
      },
    },
    {
      key: 'firstPassTime',
      dataIndex: 'firstPassTime',
      title: '咸亨上架时间',
      render: (text: any) => text && moment(text).format('YYYY-MM-DD HH:mm:ss'),
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ['descend', 'ascend'], // 第一次点击降序，第二次点击升序
      sortOrder:
        sortParams.firstPassTimeSortType === 'asc'
          ? 'ascend'
          : sortParams.firstPassTimeSortType === 'desc'
            ? 'descend'
            : null,
    },
    {
      key: 'submitTime',
      dataIndex: 'submitTime',
      title: '物料提交时间',
      render: (text: any) => text && moment(text).format('YYYY-MM-DD HH:mm:ss'),
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ['descend', 'ascend'],
      sortOrder:
        sortParams.submitTimeSortType === 'asc'
          ? 'ascend'
          : sortParams.submitTimeSortType === 'desc'
            ? 'descend'
            : null,
    },
  ]

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Search
        fieldsData={[
          'srmProductType',
          'code',
          'name',
          'brand',
          'model',
          'unitCode',
          'platformCodes',
          'firstPassStart',
          'firstPassEnd',
          'submitTimeStart',
          'submitTimeEnd',
        ]}
        keyName="ACCOUNT"
        resetState={searchState}
        onSearch={onSearch}
        ScreenKey="ACCOUNT"
      />
      <div
        className={`${Style['content']}  ${treevisible ? Style['vis'] : ''}`}
      >
        <div className={Style['btntreebox']}>
          {!treevisible ? (
            <LeftCircleFilled
              className={Style['icon']}
              onClick={onChangetree}
            />
          ) : (
            <RightCircleFilled
              className={Style['icon']}
              onClick={onChangetree}
            />
          )}
        </div>
        <div className={Style['treebox']}>
          <div
            style={{
              padding: '7px 10px',
            }}
          >
            <Input.Search
              enterButton={
                <Button type="primary" size="small">
                  <CustomeIcon
                    type="icon-fangdajing"
                    style={{ fontSize: '16px' }}
                  />
                </Button>
              }
              size="small"
              placeholder="请输入名称、编码"
              onSearch={onSearchMod}
            />
          </div>
          <div
            style={{
              height: window.innerHeight - 300,
              overflow: 'auto',
            }}
          >
            <CustomTreeAll
              treeList={treeRef}
              selectNode={selectNode}
              searchKey={searchValue}
              selectData={selectData}
            />
          </div>
        </div>
        <div className={Style['content-list']}>
          <Buttonbar title={selectData.title} onRefresh={onRefresh}>
            <Space>
              <Button size="middle" onClick={handleGoodsSubmission}>
                商品提报
              </Button>
              <Button size="middle" onClick={exportGoodsDetail}>
                导出
              </Button>
              <Button size="middle" onClick={jumpBatchImport}>
                批量导入
              </Button>
              <Button size="middle" type="primary" onClick={onAddgoods}>
                新增
              </Button>
            </Space>
          </Buttonbar>
          <Table
            loading={dataSource.loading}
            dataSource={dataSource.data}
            listColumn={listColumn}
            showSort
            rowKey="mdmId"
            pagination={{
              total: dataSource.total,
              current: pages.pageNo,
              pagesize: pages.pageSize || 25,
              onChange: onChange,
            }}
            onChangeCheck={onChangeCheck}
            onChange={(pagination: any, filters: any, sorter: any) => {
              if (sorter && sorter.field) {
                const sortField = sorter.field
                const sortOrder = sorter.order
                if (
                  sortField === 'firstPassTime' ||
                  sortField === 'submitTime'
                ) {
                  onSortChange(
                    sortField as 'firstPassTime' | 'submitTime',
                    sortOrder,
                  )
                }
              }
            }}
            Y={340}
          />
        </div>
      </div>
      <CustomModal
        title="商品提报"
        open={submissionVisible}
        modalCancel={handleGoodsSubmissionCancel}
        width={460}
        okBtnLoading={submissionLoading}
        modalSubmit={handleGoodsSubmissionSubmit}
      >
        <Form form={submissionForm}>
          <Form.Item
            label="选择项目"
            name="platformCode"
            rules={[{ required: true, message: '请选择项目' }]}
          >
            <Select
              showSearch
              optionFilterProp="label"
              getPopupContainer={() => document.body}
              options={filteredPlatformList.map((item: PlatformField) => ({
                label: item.name,
                value: item.code,
              }))}
              onChange={(value) => {
                submissionForm.setFieldsValue({
                  platformCode: value,
                  platformName: filteredPlatformList.find(
                    (item: PlatformField) => item.code === value,
                  )?.name,
                })
              }}
            />
          </Form.Item>
          <Form.Item noStyle label="项目名称" name="platformName">
            <Input hidden />
          </Form.Item>
          <Form.Item
            label="选择操作"
            name="submissionType"
            rules={[{ required: true, message: '请选择操作' }]}
          >
            <Select
              getPopupContainer={() => document.body}
              options={reportTypeList}
            />
          </Form.Item>
        </Form>
      </CustomModal>
    </div>
  )
}

export default Goodslist
import Table from '../../components/TableAntd'
import { Button, Input, Space, Tooltip, Form, Select } from 'antd'
import { RightCircleFilled, LeftCircleFilled } from '@ant-design/icons'
import CustomTreeAll from '../../components/TreeAll'
import CustomeIcon from '../../components/IconUser'
import Search from '../../components/SearchFilter'
import Buttonbar from '../../components/ButtonBar'
import Style from './goodslist.module.scss'
import usegoodslisthooks from './hooks'
import { useTypedSelector } from '../../redux/store'
import moment from 'moment'
import {
  CategorySourceData,
  PlatformField,
} from '../../modules/goodsdetailmodules/reducer'
import { useMemo } from 'react'
import CustomModal from '@/components/ModalUser'
import { reportTypeList } from '@/global/enum/product'
// 商品列表页
const Goodslist = () => {
  const { treeList } = useTypedSelector((state) => state.treeReducer)
  const {
    dataSource,
    pages,
    selectData,
    searchState,
    searchValue,
    treevisible,
    submissionVisible,
    filteredPlatformList,
    submissionLoading,
    submissionForm,
    sortParams,
    onSearch,
    onChange,
    onChangeCheck,
    onRefresh,
    onSearchMod,
    onhandlDetail,
    selectNode,
    onAddgoods,
    onChangetree,
    jumpBatchImport,
    exportGoodsDetail,
    handleGoodsSubmission,
    handleGoodsSubmissionCancel,
    handleGoodsSubmissionSubmit,
    onSortChange,
  } = usegoodslisthooks()
  const treeRef = useMemo(
    () => treeList.filter((item) => item.source !== CategorySourceData.PLM),
    [treeList],
  )

  const listColumn = [
    {
      key: 'srmProductTypeName',
      title: '物料类型',
      width: 75,
      render: (text: string) =>
        text === '落地商物料' ? '电商供应商物料' : text,
    },
    {
      key: 'code',
      title: '编码',
      width: 81,
      render: (text: any, record: any) => {
        return (
          <span className={'primaryBtn'} onClick={() => onhandlDetail(record)}>
            {text}
          </span>
        )
      },
    },
    {
      key: 'name',
      title: '名称',
      width: 94,
      render: (text: any, record: any) => {
        return record.needConfirmPic === '1' ? (
          <Tooltip
            title="图片被重新覆盖，请预览确认"
            getPopupContainer={() => document.body}
          >
            <span>{text}</span>
          </Tooltip>
        ) : (
          text
        )
      },
    },
    {
      key: 'brandName',
      title: '品牌',
      width: 95,
    },
    {
      key: 'manuCode',
      title: '型号规格',
      width: 95,
    },
    {
      key: 'unitName',
      title: '单位',
      width: 75,
    },

    {
      key: 'supplyPrice',
      title: '参考供货价',
      width: 75,
    },
    {
      key: 'relationPlatformCodeAndNames',
      title: '关联项目',
      width: 75,
      render: (text: any) => {
        return text?.map((item: any) => item.name)?.join(',')
      },
    },
    {
      key: 'pushPlatformCodeAndNames',
      title: '已推送项目',
      width: 75,
      render: (text: any) => {
        return text?.map((item: any) => item.name)?.join(',')
      },
    },
    {
      key: 'firstPassTime',
      dataIndex: 'firstPassTime',
      title: '咸亨上架时间',
      render: (text: any) => text && moment(text).format('YYYY-MM-DD HH:mm:ss'),
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ['descend', 'ascend'], // 第一次点击降序，第二次点击升序
      sortOrder:
        sortParams.firstPassTimeSortType === 'asc'
          ? 'ascend'
          : sortParams.firstPassTimeSortType === 'desc'
            ? 'descend'
            : null,
    },
    {
      key: 'submitTime',
      dataIndex: 'submitTime',
      title: '物料提交时间',
      render: (text: any) => text && moment(text).format('YYYY-MM-DD HH:mm:ss'),
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ['descend', 'ascend'],
      sortOrder:
        sortParams.submitTimeSortType === 'asc'
          ? 'ascend'
          : sortParams.submitTimeSortType === 'desc'
            ? 'descend'
            : null,
    },
  ]

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Search
        fieldsData={[
          'srmProductType',
          'code',
          'name',
          'brand',
          'model',
          'unitCode',
          'platformCodes',
          'firstPassStart',
          'firstPassEnd',
          'submitTimeStart',
          'submitTimeEnd',
        ]}
        keyName="ACCOUNT"
        resetState={searchState}
        onSearch={onSearch}
        ScreenKey="ACCOUNT"
      />
      <div
        className={`${Style['content']}  ${treevisible ? Style['vis'] : ''}`}
      >
        <div className={Style['btntreebox']}>
          {!treevisible ? (
            <LeftCircleFilled
              className={Style['icon']}
              onClick={onChangetree}
            />
          ) : (
            <RightCircleFilled
              className={Style['icon']}
              onClick={onChangetree}
            />
          )}
        </div>
        <div className={Style['treebox']}>
          <div
            style={{
              padding: '7px 10px',
            }}
          >
            <Input.Search
              enterButton={
                <Button type="primary" size="small">
                  <CustomeIcon
                    type="icon-fangdajing"
                    style={{ fontSize: '16px' }}
                  />
                </Button>
              }
              size="small"
              placeholder="请输入名称、编码"
              onSearch={onSearchMod}
            />
          </div>
          <div
            style={{
              height: window.innerHeight - 300,
              overflow: 'auto',
            }}
          >
            <CustomTreeAll
              treeList={treeRef}
              selectNode={selectNode}
              searchKey={searchValue}
              selectData={selectData}
            />
          </div>
        </div>
        <div className={Style['content-list']}>
          <Buttonbar title={selectData.title} onRefresh={onRefresh}>
            <Space>
              <Button size="middle" onClick={handleGoodsSubmission}>
                商品提报
              </Button>
              <Button size="middle" onClick={exportGoodsDetail}>
                导出
              </Button>
              <Button size="middle" onClick={jumpBatchImport}>
                批量导入
              </Button>
              <Button size="middle" type="primary" onClick={onAddgoods}>
                新增
              </Button>
            </Space>
          </Buttonbar>
          <Table
            loading={dataSource.loading}
            dataSource={dataSource.data}
            listColumn={listColumn}
            showSort
            rowKey="mdmId"
            pagination={{
              total: dataSource.total,
              current: pages.pageNo,
              pagesize: pages.pageSize || 25,
              onChange: onChange,
            }}
            onChangeCheck={onChangeCheck}
            onChange={(pagination: any, filters: any, sorter: any) => {
              if (sorter && sorter.field) {
                const sortField = sorter.field
                const sortOrder = sorter.order
                if (
                  sortField === 'firstPassTime' ||
                  sortField === 'submitTime'
                ) {
                  onSortChange(
                    sortField as 'firstPassTime' | 'submitTime',
                    sortOrder,
                  )
                }
              }
            }}
            Y={340}
          />
        </div>
      </div>
      <CustomModal
        title="商品提报"
        open={submissionVisible}
        modalCancel={handleGoodsSubmissionCancel}
        width={460}
        okBtnLoading={submissionLoading}
        modalSubmit={handleGoodsSubmissionSubmit}
      >
        <Form form={submissionForm}>
          <Form.Item
            label="选择项目"
            name="platformCode"
            rules={[{ required: true, message: '请选择项目' }]}
          >
            <Select
              showSearch
              optionFilterProp="label"
              getPopupContainer={() => document.body}
              options={filteredPlatformList.map((item: PlatformField) => ({
                label: item.name,
                value: item.code,
              }))}
              onChange={(value) => {
                submissionForm.setFieldsValue({
                  platformCode: value,
                  platformName: filteredPlatformList.find(
                    (item: PlatformField) => item.code === value,
                  )?.name,
                })
              }}
            />
          </Form.Item>
          <Form.Item noStyle label="项目名称" name="platformName">
            <Input hidden />
          </Form.Item>
          <Form.Item
            label="选择操作"
            name="submissionType"
            rules={[{ required: true, message: '请选择操作' }]}
          >
            <Select
              getPopupContainer={() => document.body}
              options={reportTypeList}
            />
          </Form.Item>
        </Form>
      </CustomModal>
    </div>
  )
}

export default Goodslist
